import { Type } from 'typebox';
import { Attachment } from '../reference/attachment.js';
export const CalloutAudio = Type.Object({
    url: Type.String({ minLength: 1 }),
    title: Type.Optional(Type.String())
});
export const Callout = Type.Object({
    title: Type.Optional(Type.String()),
    content: Type.Optional(Type.String()),
    audio: Type.Optional(CalloutAudio),
    video: Type.Optional(Attachment)
});
